import { AfterViewInit, Component, ElementRef, EventEmitter, inject, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { AppService } from '@app/app.service';
import { FieldConfig, ITrailingButtonEvent } from '../field.interface';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.scss'],
})
export class InputComponent implements OnInit, AfterViewInit {
    readonly #elementRef: ElementRef = inject(ElementRef);
    field: FieldConfig;
    group: FormGroup;
    data: { mask: string } = {
        mask: null,
    };
    outputEvent: EventEmitter<ITrailingButtonEvent> = null;
    /**
     * Конструктор
     * @param appService сервис
     */
    constructor(public appService: AppService) {}

    /**
     * Событие окончания инициализации компонента
     */
    ngOnInit() {
        if (this.field.interactionField && this.field.disabled) {
            setTimeout(() => {
                this.group.get(this.field.name).disable({ onlySelf: true, emitEvent: false });
            });
        }
        if (this.field.interactionField && this.field.required) {
            this.group.get(this.field.name).addValidators(Validators.required);
        }
        if (this.field.interactionField && this.field.minlength) {
            this.group.get(this.field.name).addValidators(Validators.minLength(+this.field.minlength));
        }
        if (this.field.interactionField && this.field.maxlength) {
            this.group.get(this.field.name).addValidators(Validators.maxLength(+this.field.maxlength));
        }
        if (this.field.interactionField && this.field.regex) {
            this.group.get(this.field.name).addValidators(Validators.pattern(this.field.regex));
        }
        if (this.field.disabled) {
            setTimeout(() => {
                this.group.get(this.field.name).disable({ onlySelf: true, emitEvent: false });
            });
        }
        setTimeout(() => {
            this.group.get(this.field.name).updateValueAndValidity({ emitEvent: false });
        });
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled) {
        this.field.disabled = disabled;
        if (this.field.disabled) {
            this.group.get(this.field.name).disable({ onlySelf: true, emitEvent: false });
        } else {
            this.group.get(this.field.name).enable({ onlySelf: true, emitEvent: false });
        }
    }

    public ngAfterViewInit(): void {
        if (this.field?.autoFocus) {
            const inputRef = this.#elementRef.nativeElement.querySelector('input') as HTMLElement;
            if (inputRef && inputRef?.clientHeight && inputRef?.clientWidth) {
                setTimeout(() => {
                    inputRef.focus();
                });
            }
        }
    }
}
